<template>
    <div class="relative">
        <div class="input-wrapper">
            <input
                id="qty_input"
                type="tel"
                v-model="content"
                :placeholder="txtPlaceholder"
                :readonly="true"
                @input="onInput()">
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';

export default {
    name: 'InputDonate',
    props: {
        //v-model
        value: Number,
        //text
        txtLabel:       { type: String, default: '' },
        txtPlaceholder: { type: String, default: '' },
        max: { type: Number}
    },
    data: function () {
        return {
            id: '',
            label: '',
            placeholder: '',
            content: this.value,
            minLength: 0,
            maxLength: 0,
            readOnly: true,
            customClass: '',
        };
    },
    watch: {
        value: function (newVal) {
            this.content = newVal;
            this.onChange();
        }
    },

    methods: {
        onChange: function () {
            this.$emit('input', this.content);
        },
        clearText: function () {
            this.content = '';
            // this.validateInput();
            this.$emit('input', '');
        },
        onInput: function () {
            if (!this.content) return;

            var quantity = this.content;
            quantity = quantity.replace(Vue.RegExp.emoji, '');
            quantity = quantity.replace(Vue.RegExp.notNumber, '');

            if (quantity == 0 && quantity.length == 1)
                quantity = 1;

            if(quantity.length == 2) {
                if (quantity[0] == 0)
                    quantity = quantity.slice(1,2);
            }

            if(quantity.length > 3) {
                quantity = Util.formatNum(quantity, 0)
            }

            this.content = quantity;

            this.$emit('input', this.content);
        },
    }

}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/components/Input/baseinput.scss";
.input-wrapper {
    width: 100%;
    input {
        width: 100%;
        background-color: #ffffff !important;
        border: 1px solid $a-gray-C4C4C4 !important; 
        border-radius: 100px;
        color: $a-gray-333333 !important;
        height: 45px;
        padding: {
            left: 10px;
            right: 10px;
        };

        text-align: center;
    }
}
</style>